<template>
    <div id="pcm-attendance-view">
        <div class="container-fluid">
            <!-- Page Heading -->
            <div class="d-sm-flex align-items-center justify-content-between mb-4">
                <h1 class="h3 mb-0 text-gray-800">Tiện ích: Chấm công</h1>
            </div>
            <!-- Content Row -->
            <div class="row">
                <div class="col-xl-12">
                    <div class="card mb-4 border-left-primary">
                        <div class="card-body">
                            <h6 class="font-weight-bold">Điều kiện lọc</h6>
                            <div class="row">
                                <div class="col-md-2 form-group">
                                    <el-date-picker
                                        v-model="form.filter.date"
                                        class="w-100"
                                        type="month"
                                        placeholder="Chọn tháng"
                                        format="MM/yyyy"
                                        value-format="yyyy-MM"
                                        :clearable="false"
                                        @change="loadData()"
                                        :picker-options="pickerOptions"
                                        >
                                    </el-date-picker>
                                </div>
                                <div v-if="$acl.check('isAdmin')" class="col-md-10 form-group">
                                    <el-select v-model="form.filter.user_id" placeholder="Nhân sự" filterable clearable @change="loadData()">
                                        <el-option v-for="user in form.option.users" :key="user.id" :label="user.full_name" :value="user.id">
                                            <div class="d-flex align-items-center">
                                                <div class="pr-2">
                                                    <avatar :username="user.first_name + ' ' + user.last_name" :size="30"></avatar>
                                                </div>
                                                <div class="w-100">
                                                    <span class="font-weight-bold">
                                                        {{user.full_name}} 
                                                    </span>
                                                    <span class="float-right">{{user.email}}</span>
                                                </div>
                                            </div>
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-12">
                    <div class="card shadow mb-4" v-loading="loadingState.list">
                        <!-- Card Header - Dropdown -->
                        <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                            <h6 class="m-0 font-weight-bold text-primary">Danh sách chấm công</h6>
                        </div>
                        <!-- Card Body -->
                        <div class="card-body text-center">
                            <el-table :data="attendances" style="width: 100%">
                            
                                <el-table-column label="Ngày chấm">
                                    <template slot-scope="scope">
                                        <span class="badge badge-heading" 
                                            :class="{'badge-success': scope.row.type == 0, 'badge-primary': scope.row.type == -1,' badge-warning': (scope.row.type >= 1 && scope.row.type <= 3), 'badge-danger': scope.row.id == 0}" 
                                            style="font-size: 100%">

                                            {{scope.row.check_date | formatDate('ddd, DD/MM')}}

                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="Giờ vào">
                                    <template slot-scope="scope">
                                        <span class="font-weight-bold" :class="{'text-danger': scope.row.type == 1 || scope.row.type == 3}">{{ scope.row.check_in | formatDate('HH:mm') }}</span>
                                        <br>
                                        <span class="small">{{scope.row.reason_late}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="Giờ ra">
                                    <template slot-scope="scope">
                                        <span class="font-weight-bold" :class="{'text-danger': scope.row.type == 2 || scope.row.type == 3}">{{ scope.row.check_out | formatCheckOut(scope.row.check_date) }}</span>
                                        <br>
                                        <span class="small">{{scope.row.reason_soon}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="Công số">
                                    <template slot-scope="scope">
                                        <span class="font-weight-bold">{{ parseFloat(scope.row.work_rate) || 0 }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="#" fixed="right" width="150">
                                    <template slot-scope="scope">
                                        <i v-if="scope.row.id > 0 && scope.row.type == 0 && scope.row.status == 1" class="fas fa-check-circle fa-lg fa-fw text-success"></i>
                                        <i v-if="scope.row.id > 0 && scope.row.type > 0 && scope.row.status == 1" class="fas fa-check-circle fa-lg fa-fw text-warning"></i>
                                        <span v-if="scope.row.id > 0 && scope.row.status == 0">
                                            <button v-if="$acl.check('isAdmin')" class="btn btn-info btn-sm" @click="confirmRequest(scope.row)">Xác nhận</button>    
                                            <i v-else class="far fa-hourglass fa-lg fa-fw"></i>
                                        </span>
                                        <span v-if="scope.row.id == 0 || scope.row.type == -1">
                                            <button v-if="scope.row.user_id == $store.state.app_user.user.id" class="btn btn-secondary btn-sm" @click="request(scope.row)">Yêu cầu</button>
                                            <span v-else >--</span>
                                        </span>
                                        <br>
                                        <span class="small">{{scope.row.note}}</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Attendance Reuest Component -->
        <att-request :dialog-visible="dialogVisible.attendance" :init-data="attendanceRequestData" @closeDialog="dialogVisible.attendance = false" @success="successAttendanceRequest" />
    </div>
</template>

<script>
import API_USER from '@/utils/api/user'
import API_ATTENDANCE from '@/utils/api/attendance'
import UserModel from '@/model/user'
import moment from 'moment'

export default {
    name: 'pcm-attendance-view',
    components: {
        'att-request': () => import('@/components/attendance/Request.vue'),
        'avatar': () => import('vue-avatar'),
    },
    data() {
        return {
            loadingState: {
                user: false,
                list: false
            },
            dialogVisible: {
                attendance: false
            },
            pickerOptions: {
                disabledDate(time) {
                return time.getTime() > Date.now();
                }
            },
            UserModel: UserModel
            ,
            form: {
                filter: {
                    user_id: this.$store.state.app_user.user.id,
                    date: moment().format('YYYY-MM')
                },
                option: {
                    users: []
                }
            },
            attendances: [],
            attendanceRequestData: {}
        }
    },
    created() {
        let self = this
        this.$emit('activeMenu', 'my_attendance')
        self.loadData()
        self.loadOption()
    },
    methods: {
        loadOption() {
            let self = this
            self.loadingState.filter = true
            API_USER.getOption(self.$axios, {}, function(data){
                self.loadingState.filter = false
                if (data.status) {
                    self.form.option.users = data.data
                }
            }, function(error){})
        },
        loadData() {
            let self = this
            self.loadingState.list = true
            API_ATTENDANCE.getList(self.$axios, self.form.filter, function(data){
                self.loadingState.list = false
                if (data.status) {
                    self.attendances = data.data
                }
            }, function(error){
                self.loadingState.list = false
            })
        },
        request(row) {
            if (row.id > 0) {
                this.attendanceRequestData = row
            } else {
                this.attendanceRequestData = row
            }
            this.dialogVisible.attendance = true
        },
        confirmRequest(row) {
            let self = this
            let content = '<b>Lý do</b>: ' + row.note
            this.showConfirmLoadingMessage('warning', 'Xác nhận chấm công', content, (action, instance, done) => {
                if (action === 'confirm') {
                    instance.confirmButtonLoading = true
                    let form = {
                        id: row.id
                    }
                    API_ATTENDANCE.confirmRequest(self.$axios, form, (data) => {
                        instance.confirmButtonLoading = false
                        if (data.status) {
                            self.showMessage('success', 'Xác nhận thành công !')
                            done()
                            self.loadData()
                        }
                    }, (error) => {
                        instance.confirmButtonLoading = false
                    })
                } else {
                    done();
                }
            })
        },
        successAttendanceRequest(data) {
            this.loadData()
            this.dialogVisible.attendance = false
        }
    }
}
</script>

